/**
 * Topology Hooks
 *
 * TanStack Query hooks for network topology
 */

import { useQuery } from '@tanstack/react-query';
import { apiFetch } from '../client';
import type { TopologyResponse } from '../types/topology';

/** Query keys for topology */
export const topologyKeys = {
  all: ['topology'] as const,
  data: () => [...topologyKeys.all, 'data'] as const,
};

/**
 * Fetch network topology
 */
export function useTopology() {
  return useQuery({
    queryKey: topologyKeys.data(),
    queryFn: () => apiFetch<TopologyResponse>('/api/topology'),
    staleTime: 30_000, // 30 seconds
    refetchOnWindowFocus: true, // Keep topology fresh
  });
}
